<template>
    <el-date-picker
        v-model="value"
        size="mini"
        type="datetimerange"
        value-format="yyyy-MM-dd HH:mm:ss"
        :picker-options="pickerOptions"
        :editable="canEdit"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        align="right"
        @change="setSelectedTime">
    </el-date-picker>
</template>

<script>
    import {mapState, mapActions} from 'vuex';

    const shortcutsTimePicker = hours => {
        let end = new Date();
        let start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * hours);
        return [start, end];
    };

    export default {
        data() {
            return {
                canEdit: false,
                pickerOptions: {
                    shortcuts: [{
                        text: '最近2小时',
                        onClick(picker) {
                            const timeRange = shortcutsTimePicker(2);
                            picker.$emit('pick', timeRange);
                        }
                    }, {
                        text: '最近6小时',
                        onClick(picker) {
                            const timeRange = shortcutsTimePicker(6);
                            picker.$emit('pick', timeRange);
                        }
                    }, {
                        text: '最近12小时',
                        onClick(picker) {
                            const timeRange = shortcutsTimePicker(12);
                            picker.$emit('pick', timeRange);
                        }
                    }, {
                        text: '最近1天',
                        onClick(picker) {
                            const timeRange = shortcutsTimePicker(24);
                            picker.$emit('pick', timeRange);
                        }
                    }, {
                        text: '最近3天',
                        onClick(picker) {
                            const timeRange = shortcutsTimePicker(24 * 3);
                            picker.$emit('pick', timeRange);
                        }
                    }, {
                        text: '最近7天',
                        onClick(picker) {
                            const timeRange = shortcutsTimePicker(24 * 7);
                            picker.$emit('pick', timeRange);
                        }
                    }, {
                        text: '最近15天',
                        onClick(picker) {
                            const timeRange = shortcutsTimePicker(24 * 15);
                            picker.$emit('pick', timeRange);
                        }
                    }]
                }
            };
        },
        computed: {
            ...mapState({
                initSelectedTime: state => state.common.initSelectedTime
            }),
            value: {
                get() {
                    return this.initSelectedTime;
                },
                set(time) {
                    this.$store.dispatch('setSelectedTime', time);
                }
            }
        },
        methods: {
            ...mapActions([
                'setSelectedTime'
            ])
        }
    };
</script>

